import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import i18n from "../../../../i18n";
import { Link } from "react-router-dom";
import { getUserInfo } from "../../../../models/users";
import { getLoggedUser } from "../../../../state/user";
import { createWallet, getAllWallets, updateWallet } from "../../../../models/wallet";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { HomeBanner } from "../../../home/homeBanner";
import { CustomTitle } from "../../../helpers/customTitle";
import { SideBar } from "./../../sidebar";
import { getAllOrganization } from "../../../../models/organization";
import { getAllGroups } from "../../../../models/groups";
import '../../../../styles/components/wallet.scss'
import { BankAccountModal } from "./components/BankAccountModal";
import { tableStyles } from "../../../../styles/components/js/tableStyle";
import HeaderBanner from "../../../common/HeaderBanner";
import { TRANSACTION_TYPES, USER_TRANSACTION_STATUS } from "../../../../constants/status";


const user = getLoggedUser();
const wallet_types = {
  admin: i18n.t("added_by_admin"),
  sitevisit: i18n.t("site_visit"),
  enroll: i18n.t("enroll"),
  wallet_recharge: i18n.t("wallet_recharge"),
  withdraw: i18n.t("withdraw"),
};

// Pure presentation helper - maps a status code to a badge style.
// Does not affect any business logic, only which CSS class is applied.
const status_badge_classes = {
  A: "wal-badge wal-badge--approved",
  P: "wal-badge wal-badge--pending",
  F: "wal-badge wal-badge--pending",
  W: "wal-badge wal-badge--withdraw",
  WA: "wal-badge wal-badge--approved",
  R: "wal-badge wal-badge--refunded",
};


const wallet_statuses = {
  A: i18n.t("approved"),
  P: "Waiting for admin approval",
  F: i18n.t("waiting_for_finance_approval"),
  W: "Withdraw requested",
  WA: i18n.t("withdraw_request_approved_by_admin"),
  R: "Refunded",
};
export class WalletNew extends React.Component {
  constructor() {
    super();
    this.state = {
      withdraw_popup: false,
      file_receipt: null,
      bank_account_modal: false,
      is_loading: false,
      user_info: {},
      transactions: [],
      input: {
        bank: user?.bank,
        beneficiary: user?.beneficiary,
        account_number: user?.account_number,
      },
      balance: 0,
      credit_sum: 0,
      debit_sum: 0,
      balance_sum: 0,
      hold_sum: 0,
      client_due: 0,
      list: {
        page: 1,
        limit: 15,
        client: 1,
      },
      is_wthdraw_req_sending: false,
      clients: [],
      groups: [],
      columns: [
        {
          name: "ID",
          cell: (row) => row.id,
          sortable: true,
          wrap: true,
          width: "70px",
        },
        {
          name: i18n.t("transaction"),
          sortable: true,
          cell: (row) => row.transaction_id,
        },
        {
          name: i18n.t("credit"),
          cell: (row) => row.credit,
        },
        {
          name: i18n.t("debit"),
          cell: (row) => row.debit,
        },
        {
          name: i18n.t("reference"),
          cell: (row) => row.reference,
          wrap: true,
        },
        {
          name: i18n.t('type'),
          wrap: true,
          cell: (row) => {
            return TRANSACTION_TYPES[row.type]?.text || row.type || '-';
          },
        },
        {
          name: i18n.t('status'),
          cell: (row) =>
            `${row.status ? USER_TRANSACTION_STATUS[row.status]?.text || row.status : ''}`,
        },
        {
          name: i18n.t("date"),
          wrap: true,
          cell: (row) => row.created_at,
        },
      ],
    };
    this.updateWalletRow = this.updateWalletRow.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleBankAccountSelect = this.handleBankAccountSelect.bind(this);
  }

  componentDidMount() {
    this.loadAllOrganisation();
    this.loadAllGroups();
    this.checkUserWallet();
    this.loadAllTransactions();
  }

  handlePageChange = (page) => {
    let { list } = this.state;
    let currentPage = page;
    list["page"] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ list: list });
    let qstring = new URLSearchParams(list).toString();
    this.setState({ query: qstring });
    this.loadAllTransactions();
  };

  handleChange(event) {
    let { user_info, input } = this.state;
    if (event.target.name === "amount") {
      if (
        isNaN(event.target.value) ||
        (event.target.value && event.target.value < 1)
      ) {
        swal(i18n.t("Warning"), "Invalid amount", "warning");
        return;
      }
      if (Number(event.target.value) > Number(user_info.wallet_amount)) {
        swal(
          i18n.t("Warning"),
          `Invalid amount!!!. Amount should be less than ${user_info.wallet_amount}`,
          "warning"
        );
        return;
      }
    }
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === "amount") {
      let balance = user_info.wallet_amount - event.target.value;
      this.setState({ balance: balance });
    }
  }

  // ── Optional reference document for withdraw ──────────────
  onWithdrawFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      swal("Failed", "Please upload a PDF, JPG or PNG file.", "error");
      return;
    }
    if (file.size / 1024 > 5120) {
      swal("Failed", "File size should be less than 5MB", "error");
      return;
    }
    this.setState({ file_receipt: file });
  };

  removeWithdrawFile = () => this.setState({ file_receipt: null });

  handleSearchChange(event) {
    let { list } = this.state;
    list[event.target.name] = event.target.value;
    this.setState({ list });
    if (event.target.name === "client") {
      this.loadAllGroups();
    }
  }

  /**
   * Called from BankAccountModal when the user picks (or just added) a
   * saved bank account. Fills the withdraw form fields only - does not
   * touch the rest of the withdraw flow.
   */
  handleBankAccountSelect(account) {
    let { input } = this.state;
    input.bank = account.bank;
    input.beneficiary = account.beneficiary;
    input.account_number = account.account_number;
    this.setState({ input });
  }

  async loadAllOrganisation() {
    const response = await getAllOrganization();
    let clients = response.data;
    this.setState({ clients });
  }

  async loadAllGroups() {
    let q = "";
    let { list } = this.state;
    if (list.client) {
      q += `organization=${list.client}`;
    }
    const response = await getAllGroups(q);
    let groups = response.data;
    this.setState({ groups });
  }

  async updateWalletRow(status, row, e) {
    e.preventDefault();
    swal({
      title: i18n.t("warn_message_withdraw_amt"),
      text: i18n.t("warn_message_desc_withdraw_amt"),
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t("confirm"),
    }).then(async function () {
      let payload = { status: status, id: row.id, user: user.id };
      const response = await updateWallet(payload, row.id);
      if (response && response.success) {
        swal(i18n.t("success"), i18n.t("withdraw_request_message"), "success");
        this.loadAllTransactions();
      }
    });
  }

  async checkUserWallet() {
    this.setState({ is_loading: true });
    const response = await getUserInfo(user.id);
    if (response && response.success) {
      let data = response.data;
      this.setState({ user_info: data });
      this.setState({ is_loading: false });
      let { input } = this.state;
      input.amount = data.wallet_amount;
      this.setState({ input });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async loadAllTransactions() {
    let { list } = this.state;
    let qstring = new URLSearchParams(list).toString();
    this.setState({ query: qstring });
    let q = `customer=${user.id}&${qstring}`;
    this.setState({ is_loading: true });
    const response = await getAllWallets(q);
    let transactions = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ transactions: transactions });
      this.setState({ totalRows: meta.total });
      this.setState({
        credit_sum: meta["credit_sum"],
        debit_sum: meta["debit_sum"],
        balance_sum: meta["balance_sum"],
        hold_sum: meta["hold_sum"],
        client_due: meta["client_due"],
      });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.validate()) {
      return;
    }

    this.setState({ is_wthdraw_req_sending: true });

    try {
      const fields = {
        no_balance_update: false,
        user: user.id,
        type: "withdraw",
        debit: this.state.input.amount,
        bank: this.state.input.bank,
        beneficiary: this.state.input.beneficiary,
        account_number: this.state.input.account_number,
        credit: 0,
        status: "W",
        method: "offline",
      };

      // file_receipt is now required, so always send as FormData
      const formData = new FormData();
      Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
      formData.append('file_receipt', this.state.file_receipt, this.state.file_receipt.name);

      const response = await createWallet(formData);
      if (response.success) {
        swal(i18n.t("success"), i18n.t("withdraw_display_message"), "success", {
          buttons: false,
          timer: 10000,
        })
          .then(() => {
            this.setState({ is_wthdraw_req_sending: false });
            this.loadAllTransactions();
            this.checkUserWallet();
            this.setState({ withdraw_popup: false, file_receipt: null });
          })
          .catch((response) => {
            this.setState({ is_wthdraw_req_sending: false });
            swal("Failed", response.message, "error");
          });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            error_message += "\n" + resObject[key];
          }
        }
        swal("Failed", error_message, "error");
        this.setState({ is_wthdraw_req_sending: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ is_wthdraw_req_sending: false });
    }
  }

  validate() {
    let input = this.state.input;
    let errors = {};
    let isValid = true;

    if (!input['amount']) {
      isValid = false;
      errors['user'] = 'Enter an amount';
    }

    if (!this.state.file_receipt) {
      isValid = false;
      errors['file_receipt'] = i18n.t('reference_document_required');
      swal('Failed', i18n.t('reference_document_required'), 'error');
    }

    this.setState({
      errors: errors,
    });
    return isValid;
  }

  render() {
    let { user_info, transactions, groups } = this.state;
    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('my_wallet')} />

        <section className="wal-page">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>

              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                {this.state.is_loading && (
                  <React.Fragment>
                    <div className="wal-skel-hero">
                      <div className="wal-skel-hero__top">
                        <span className="wal-skel-hero__brand" />
                        <span className="wal-skel-hero__pill" />
                      </div>
                      <div className="wal-skel-hero__body">
                        <div>
                          <span className="wal-skel-hero__label" />
                          <span className="wal-skel-hero__amount" />
                        </div>
                        <span className="wal-skel-hero__btn" />
                      </div>
                    </div>

                    <div className="wal-skel-stats">
                      {[1, 2, 3, 4].map((n) => (
                        <div className="wal-skel-stat" key={n}>
                          <span className="wal-skel-stat__icon" />
                          <div className="wal-skel-stat__text">
                            <span className="wal-skel-stat__label" />
                            <span className="wal-skel-stat__value" />
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="wal-skel-panel">
                      <div className="wal-skel-filters">
                        <span />
                        <span />
                        <span />
                        <span />
                        <span style={{ width: "40px" }} />
                      </div>
                      {[1, 2, 3, 4, 5, 6].map((n) => (
                        <div className="wal-skel-row" key={n}>
                          <span />
                          <span />
                          <span />
                          <span />
                          <span />
                          <span />
                          <span />
                          <span />
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                )}

                {!this.state.is_loading && (
                  <React.Fragment>
                    {/* Balance hero card */}
                    <div className="wal-hero">
                      <div className="wal-hero__top">
                        <div className="wal-hero__brand">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/mzadcom-wallet-icon.png"
                            }
                            alt="wallet"
                          />
                          <span>{i18n.t("my_wallet")}</span>
                        </div>
                        <Link to="/wallet-manage" className="wal-hero__add">
                          <i className="fa fa-plus-circle" />
                          {i18n.t("add_fund")}
                        </Link>
                      </div>

                      <div className="wal-hero__body">
                        <div>
                          <div className="wal-hero__label">
                            {i18n.t("balance")}
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/refresh-blue-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <div className="wal-hero__amount">
                            <span>{user_info.wallet_amount}</span>
                            <span className="wal-hero__currency">
                              {i18n.t("omr")}
                            </span>
                          </div>
                        </div>

                        <button
                          className="wal-hero__withdraw"
                          onClick={() => {
                            if (user_info.wallet_amount < 1) {
                              return;
                            }
                            this.setState({ withdraw_popup: true });
                          }}
                        >
                          <i className="fa fa-money" />
                          {i18n.t("withdraw")}
                        </button>
                      </div>
                    </div>

                    {/* Summary chips */}
                    {transactions.length > 0 && (
                      <div className="wal-stats">
                        <div className="wal-stat wal-stat--deposit">
                          <div className="wal-stat__icon">
                            <i className="fa fa-arrow-down" />
                          </div>
                          <div className="wal-stat__text">
                            <div className="wal-stat__label">
                              {i18n.t("deposit")}
                            </div>
                            <div className="wal-stat__value">
                              {this.state.credit_sum} {i18n.t("omr")}
                            </div>
                          </div>
                        </div>
                        <div className="wal-stat wal-stat--due">
                          <div className="wal-stat__icon">
                            <i className="fa fa-clock-o" />
                          </div>
                          <div className="wal-stat__text">
                            <div className="wal-stat__label">
                              {i18n.t("client_due")}
                            </div>
                            <div className="wal-stat__value">
                              {this.state.client_due} {i18n.t("omr")}
                            </div>
                          </div>
                        </div>
                        <div className="wal-stat wal-stat--hold">
                          <div className="wal-stat__icon">
                            <i className="fa fa-lock" />
                          </div>
                          <div className="wal-stat__text">
                            <div className="wal-stat__label">
                              {i18n.t("hold")}
                            </div>
                            <div className="wal-stat__value">
                              {this.state.hold_sum} {i18n.t("omr")}
                            </div>
                          </div>
                        </div>
                        <div className="wal-stat wal-stat--withdraw">
                          <div className="wal-stat__icon">
                            <i className="fa fa-arrow-up" />
                          </div>
                          <div className="wal-stat__text">
                            <div className="wal-stat__label">
                              {i18n.t("withdraw")}
                            </div>
                            <div className="wal-stat__value">
                              {this.state.debit_sum} {i18n.t("omr")}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Filters + table */}
                    <div className="wal-panel">
                      <div className="wal-filters">
                        <div className="wal-field">
                          <select
                            data-placeholder="Select Group"
                            name="group"
                            value={this.state.list.group}
                            onChange={this.handleSearchChange}
                          >
                            <option value="">{i18n.t("select_group")}</option>
                            {groups.length > 0 &&
                              groups.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {item.group_name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="wal-field">
                          <input
                            type="date"
                            placeholder={i18n.t("from_date")}
                            name="fdate"
                            value={this.state.list.fdate}
                            onChange={this.handleSearchChange}
                          />
                        </div>
                        <div className="wal-field">
                          <input
                            type="date"
                            placeholder={i18n.t("to_date")}
                            name="tdate"
                            value={this.state.list.tdate}
                            onChange={this.handleSearchChange}
                          />
                        </div>
                        <div className="wal-field">
                          <select
                            name="pay_type"
                            value={this.state.list.pay_type}
                            onChange={this.handleSearchChange}
                          >
                            <option value="">{i18n.t("type")}</option>
                            <option value="online">{i18n.t("online")}</option>
                            <option value="offline">{i18n.t("offline")}</option>
                            <option value="wallet">{i18n.t("wallet")}</option>
                          </select>
                        </div>
                        <button
                          type="button"
                          className="wal-search-btn"
                          onClick={() => this.loadAllTransactions()}
                        >
                          <i className="fa fa-search" />
                        </button>
                      </div>

                      <div className="wal-field" style={{ marginTop: "10px", maxWidth: "260px" }}>
                        <select
                          name="trans_type"
                          value={this.state.list.trans_type}
                          onChange={this.handleSearchChange}
                        >
                          <option value="">
                            {i18n.t("transaction") + " " + i18n.t("type")}
                          </option>
                          <option value="deposit">{i18n.t("deposit")}</option>
                          <option value="withdraw">{i18n.t("withdraw")}</option>
                          <option value="hold">{i18n.t("hold")}</option>
                        </select>
                      </div>

                      {transactions.length > 0 ? (
                        <div className="Data-Listing">
                          <DataTable
                            title=""
                            fixedHeader
                            columns={this.state.columns}
                            data={transactions}
                            customStyles={tableStyles}

                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={15}
                            paginationDefaultPage={this.state.currentPage}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: i18n.t("transactions_per_page"),
                              rangeSeparatorText: i18n.t("out"),
                            }}
                            onChangePage={this.handlePageChange}
                          />
                        </div>
                      ) : (
                        <div className="wal-empty">
                          <div className="wal-empty__icon">
                            <i className="fa fa-inbox" />
                          </div>
                          <div>No transactions to show yet.</div>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </section>

        <Modal
          show={this.state.withdraw_popup}
          onHide={() => this.setState({ withdraw_popup: false })}
          className="wal-wd-modal"
          centered
        >
          <Modal.Header closeButton className="wal-wd-head">
            <h5>{i18n.t("withdraw")}</h5>
          </Modal.Header>
          <Modal.Body className="wal-wd-body">
            <div className="wal-wd-note">
              {i18n.t("withdraw_display_message")}
            </div>

            {!this.state.bank_account_modal && (
              <React.Fragment>
                <button
                  type="button"
                  className="wal-wd-saved-btn"
                  onClick={() => this.setState({ bank_account_modal: true })}
                >
                  <i className="fa fa-bank" />
                  Use Saved Account
                </button>

                <div className="wal-wd-divider">or enter manually</div>
              </React.Fragment>
            )}

            {/* Expands inline in place of the button above - no separate modal */}
            {this.state.bank_account_modal && (
              <BankAccountModal
                onHide={() => this.setState({ bank_account_modal: false })}
                onSelect={this.handleBankAccountSelect}
              />
            )}

            {!this.state.bank_account_modal && (
              <form
                id="wallet-withdraw"
                tabIndex="500"
                autoComplete="off"
              >
                <div className="wal-wd-field">
                  <label>{i18n.t("bank")}</label>
                  <input
                    type="text"
                    placeholder={i18n.t("bank")}
                    name="bank"
                    value={this.state.input.bank}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="wal-wd-field">
                  <label>{i18n.t("beneficiary")}</label>
                  <input
                    type="text"
                    placeholder={i18n.t("beneficiary")}
                    name="beneficiary"
                    value={this.state.input.beneficiary}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="wal-wd-field">
                  <label>{i18n.t("account_number")}</label>
                  <input
                    type="text"
                    placeholder={i18n.t("account_number")}
                    name="account_number"
                    value={this.state.input.account_number}
                    onChange={this.handleChange}
                  />
                </div>

                <div className="wal-wd-field">
                  <label>
                    {i18n.t("withdraw")} {i18n.t("amount")}
                  </label>
                  <div className="wal-wd-amount-row">
                    <input
                      type="text"
                      placeholder={i18n.t("amount")}
                      name="amount"
                      value={this.state.input.amount}
                      onChange={this.handleChange}
                    />
                    <div className="wal-wd-balance-chip">
                      {i18n.t("balance")}: {this.state.balance}
                    </div>
                  </div>
                </div>

                {/* ── Optional reference document ── */}
                <div className="wal-wd-field">
                  <label>
                    {i18n.t('reference_document')} <span style={{ color: '#dc2626' }}>*</span>
                  </label>

                  {!this.state.file_receipt ? (
                    <label className="wal-wd-file">
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: 'none' }}
                        onChange={this.onWithdrawFileChange}
                      />
                      <i className="fa fa-upload" />
                      <span>{i18n.t('upload_reference_hint')}</span>
                    </label>
                  ) : (
                    <div className="wal-wd-file wal-wd-file--selected">
                      <i className="fa fa-file-o" />
                      <span className="wal-wd-file__name">{this.state.file_receipt.name}</span>
                      <button
                        type="button"
                        className="wal-wd-file__remove"
                        onClick={this.removeWithdrawFile}
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  )}

                  {this.state.errors?.file_receipt && (
                    <span className="wal-wd-error">{this.state.errors.file_receipt}</span>
                  )}
                </div>

                <button
                  type="button"
                  className="wal-wd-submit"
                  onClick={this.handleSubmit}
                  disabled={this.state.is_wthdraw_req_sending}
                >
                  {!this.state.is_wthdraw_req_sending && (
                    <React.Fragment>
                      <i className="fa fa-save" />
                      {i18n.t("submit")}
                    </React.Fragment>
                  )}
                  {this.state.is_wthdraw_req_sending && (
                    <React.Fragment>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {i18n.t("loading")}
                    </React.Fragment>
                  )}
                </button>
              </form>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}